/* eslint-disable no-undef */

const method = {
  get(url) {
    return new Promise(resolve => {
      fetch(url)
        .then(resp => resp.json())
        .then(data => resolve(data));
    });
  },

  async post(url, data,errorTag) {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })

      const result = await response.json();
      // Check if the response is successful (status code in the range 200-299)
      if (!response.ok) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      window.logToSentry(
        'Cart Error',
        [{ name: errorTag, value: 'cart-error' }],
        [{ name: 'error', value: error }]
      );
    }
  }
};

export default {
  status: {
    ideal: 0,
    progress: 1,
    adding: 2,
    empty: 3
  },

  fetch() {
    return method.get('/cart.js');
  },

  fetchInventory() {
    return method.get('/cart?view=inventory');
  },

  add(item) {
    /**
     * 	Payload Format::
     *
     * 	{
     * 		id: 36110175633573,
     * 		quantity: 2
     * 	}
     */
    const items = Array.isArray(item) ? item : [item];
    return method.post('/cart/add.js', { items },'Add API')
  },

  update(data) {
    /**
     * 	Payload Format::
     *
     * 	{
     * 		updates: { 794864053: 0 }
     * 	}
     */
    return method.post('/cart/update.js', {
      updates: data
    },'Update API');
  },

  change(data) {
    /**
     * 	Payload Format::
     *
     * 	{
     * 		id: 1223123123,
     * 		properties: { 'gift_wrap': true }
     * 	}
     */
    return method.post('/cart/change.js', data,'Change API');
  },

  updateNote(note = '') {
    /**
     *  Payload Format::
     *
     * 	{
     *		note: 'This is gift for you!'
     * 	}
     */
    return method.post('/cart/update.js', {
      note
    });
  },

  /**
   * Apply or replace discount codes on the cart object (Ajax Cart API).
   * Pass a comma-separated string of codes, or '' to clear all codes.
   * Response includes discount_codes: [{ code, applicable }].
   */
  updateDiscount(discount = '') {
    return method.post('/cart/update.js', {
      discount
    }, 'Discount API');
  },

  clear() {
    return method.post('/cart/clear.js','Clear API');
  },
};
